module.exports = __webpack_public_path__ + "static/img/3s-info-b1.bd3f9f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-b1.png
// module id = EG1Y
// module chunks = 0